import React from "react";
import { Rocket } from "lucide-react";

export default function ComingSoon({ title, phase, compact = false }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center ${compact ? "py-20" : "min-h-[70vh]"} px-6`}>
      <div className="w-16 h-16 rounded-2xl bg-[#FF5500]/10 border border-[#FF5500]/30 flex items-center justify-center mb-6">
        <Rocket size={28} className="text-[#FF5500]" />
      </div>
      <span className="text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full bg-[#F59E0B]/15 text-[#F59E0B] border border-[#F59E0B]/30 mb-4">
        Faz {phase}
      </span>
      <h2 className="font-display font-extrabold text-2xl sm:text-3xl text-white">{title}</h2>
      <p className="text-sm text-[#A0A0B2] mt-2 max-w-md">
        Bu modül Faz {phase} kapsamında geliştirilecek. Mimari ve veri modeli bu özelliği destekleyecek şekilde hazır bırakıldı.
      </p>
    </div>
  );
}
